import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from "react";
import { Tab, Typography } from "@parkschannel/ui";
import classNames from "classnames";
export const CounterTabsButton = /*#__PURE__*/ memo((param)=>{
    let { children , tabId , total , className  } = param;
    return /*#__PURE__*/ _jsxs(Tab.TabButton, {
        tabId: tabId,
        className: classNames(className),
        children: [
            children,
            /*#__PURE__*/ _jsx(Typography, {
                component: "span",
                variant: "bodySmall",
                className: classNames("text-neutral-700 px-1 font-medium inline-block min-w-[20px] h-5 bg-neutral-100 rounded-full text-center ml-1 !leading-5"),
                children: total
            })
        ]
    });
}, isEqual);
function isEqual(prevProps, nextProps) {
    return prevProps.tabId === nextProps.tabId && prevProps.total === nextProps.total;
}
